import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import * as actions from './job-status-summary.actions';
import { JobStatusSummary } from './job-status-summary.model';

export interface State {
    ids: Array<string>;
    entities: { [id: string]: JobStatusSummary };
}

export const initialState: State = {
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: actions.Actions): State {
    switch (action.type) {
        case actions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case actions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case actions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status-summary-item/job-status-summary.reducer.ts